
import RecommendFoodItem from "./RecommendFoodItem.vue";
import { FoodRecommendationListLine } from "@/types/home";
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  components: {
    RecommendFoodItem
  },
  name: "RecommendFoodLine",
  props: {
    data: {
      type: FoodRecommendationListLine,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const getList = () => {
      return props.data ? props.data.foods : null;
    };
    const selectFood = (id: string, type: string, foodId: string) => {
      NativeClient.sendDebugLog(
        "RecommendFoodLine selectFood id=" + id + " type=" + type + " foodId=" + foodId
      );
      context.emit("select-food", id, type, foodId);
    };
    return {
      getList,
      selectFood
    };
  }
});
